import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { Platform } from '@ionic/angular';
import { advertisement, ServiceService } from '../service.service';
import { PointsUser } from './badges-utils';

@Component({
  selector: 'app-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss'],
})
export class BadgesComponent implements OnInit {
  public pointsUser:PointsUser;
  public points:number = 0;
  public nivel:string = '';
  public progress:number = 0;
  public frame:string = "";
  public currenteCampaign:any;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(public services:ServiceService,
    private router: Router,
    private platform: Platform,
    private oneSignal: OneSignal
  ) { 
    this.initializeApp();
  }

  async ngOnInit() {
    // this.frame = "https://test-bucket-72bc5c3f-5c53-4442-9610-58d5c984afb1.s3.amazonaws.com/Frames/bronce-0.svg";
    this.isMovil = this.services.isMovil();
    this.getBadgesUser();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(4);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  async getBadgesUser(){
    (await this.services.getBadges()).subscribe(
      (data:any)=>{
        this.pointsUser = data.pointsUser;
        this.frame = data.pointsUser?.frame;
        this.currenteCampaign = data?.currenteCampaign;
        if(this.frame) this.frame+'?123456789';
        localStorage.removeItem("BadgesEarned");
        localStorage.removeItem("BadgesAvailables");
        localStorage.removeItem("Leader");
        localStorage.removeItem("campaign");
        localStorage.removeItem("currenteCampaign");
        localStorage.setItem("BadgesEarned", JSON.stringify(data.badgesUser));
        localStorage.setItem("BadgesAvailables", JSON.stringify(data.catBadges || []));
        localStorage.setItem("Leader", JSON.stringify(data.usersPointsAsc || []));
        localStorage.setItem("campaign", JSON.stringify(data.userscampaign || []));
        localStorage.setItem("currenteCampaign", JSON.stringify(data.currenteCampaign || {}));
        this.router.navigate(['/badges/earned']);
      },
      (error) => {
        console.log(error);
      }
    )
  }

  initializeApp() {
    this.platform.ready().then(()=> {
      this.setupPush();
    });
  }

  setupPush() {
    // I recommend to put these into your environment.ts
    this.oneSignal.startInit('ac5cca1e-1623-4144-95c2-b481605564ea', '576684940504');
 
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);
 
    // Notifcation was received in general
    this.oneSignal.handleNotificationReceived().subscribe(data => {
      let msg = data.payload.body;
      let title = data.payload.title;
      let additionalData = data.payload.additionalData;
      //this.showAlert(title, msg, additionalData.task);
    });
 
    // Notification was really clicked/opened
    this.oneSignal.handleNotificationOpened().subscribe(data => {
      // Just a note that the data is a different place here!
      let additionalData = data.notification.payload.additionalData;
 
      //this.showAlert('Notification opened', 'You already read this before', additionalData.task);
    });
    this.oneSignal.sendTag("user_type","Recompensas");
    this.oneSignal.setLogLevel({logLevel: 6, visualLevel: 0});
    this.oneSignal.endInit();

  }

}